import Footer from '../components/Footer/Footer';
import Header from '../components/Header/Header';
import Main from '../components/Applies/ApplicationResult';

export default function ApplicationResult() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}
